import React, { useState, useEffect } from 'react'
import axios from 'axios';
import ChatModal from './ChatModal';
import { Drawer, Space, Button, Typography, Statistic, Flex } from "antd";
import moment from 'moment'
import TableRow from './TableRow';
import "./Report.css";
import NoDataFound from '../../../../../component/common/NoDataFound';
const { Title, Text } = Typography;

const ReportTable = (props) => {
    const f_user = props.tableRow && props.tableRow.length > 0 ? props.tableRow[0].name : 'FU';
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');

    const [chatData, setChatData] = useState([]);
    const [chatSession, setChatSession] = useState([]);
    const [open, setOpen] = useState(false);
    const [sessionId, setSessionId] = useState();
    const [nextPart, setNextPart] = useState();

    const onClose = () => {
        setOpen(false);
    }

    const onChatHandel = async(data) => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        setOpen(true);
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        const api_params = {
            room: data.room,
            sass_id: localStorage.getItem('sass_id')
        };

        await axios.post(`${api_base_url}admin/get-chat-data`, api_params, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                setChatData(res.data.data.chatData);
                setChatSession(res.data.data.session[0]);
                const tt = `Duration: ${data.duration}, Start On: ${moment(res.data.data.session[0].created_at).format("D MMM YYYY, H:mm")}`;
                setSessionId(res.data.data.session[0].session_id);
                setNextPart(tt);
            } else if(res.data.status === 'error') {
                //toast.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    
    return (
        <>
        <div className="table-responsive cdr-report-table-container">
            <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer cdr_report_table">
                <thead className='cdr_report_table_head'>
                    <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                        <th className="w-80px sorting min-w-80px">
                            Action
                        </th>
                        <th className="w-150px sorting min-w-100px">
                            Bot Name
                        </th>
                        <th className="w-150px sorting min-w-100px">
                            Started On
                        </th>
                        <th className="w-150px sorting min-w-100px">
                            Ended On
                        </th>
                        <th className="w-150px sorting min-w-100px">
                            Duration
                        </th>
                        <th className="w-80px sorting min-w-80px">
                            Dialogues
                        </th>

                        {/* <th className="w-250px sorting min-w-150px">
                            Session Details
                        </th> */}
                        <th className="w-250px sorting min-w-100px">
                            Source
                        </th>
                        {/* <th className="w-250px sorting min-w-100px">
                            Routing
                        </th> */}
                        <th className="w-250px sorting min-w-200px">
                            User Details
                        </th>
                        <th className="w-250px sorting min-w-100px">
                            Enquiry
                        </th>
                        <th className="w-250px sorting min-w-100px">
                            Status
                        </th>
                        {/* <th className="w-250px sorting min-w-100px">
                            Intent
                        </th>
                        <th className="w-250px sorting min-w-100px">
                            Entity
                        </th>
                        <th className="w-250px sorting min-w-100px">
                            Information
                        </th> */}
                        <th className="w-250px sorting min-w-100px">
                            Feedback
                        </th>
                        {/* <th className="w-250px sorting min-w-100px">
                            External Action
                        </th> */}
                        <th className="w-250px sorting min-w-200px">
                            Handover Details
                        </th>
                    </tr>
                </thead>
                <tbody className="text-gray-600 fw-semibold set-system-user-list cdr_report_table_body">
                    {props.tableRow.map((row, index) => (
                        <TableRow row={row} key={index} onChatButtonClick={onChatHandel} />
                    ))}
                    {props.tableRow.length == 0 &&<tr>
                        <td colSpan="10" className="text-center">
                            <NoDataFound className="w-30" setHtml="No Data found" />
                        </td>
                    </tr>}
                </tbody>
            </table>
        </div>

        <Drawer 
            title={
                <div>
                    <Title className='mb-0 fs-3 text-gray-800'>Session Id: {sessionId}</Title>
                    <Text className='text-gray-400'>{nextPart}</Text>
                </div>
            } 
            onClose={onClose} 
            open={open} 
            width={1200} 
            extra={
                <>
                    {/* <Flex gap="middle" horizontal>
                        <span className="fw-bold text-gray-600 fs-6">Intent</span>
                        <span className="fw-bold text-gray-600 fs-6">Entity</span>
                        <span className="fw-bold text-gray-600 fs-6">Information</span>
                        <span className="fw-bold text-gray-600 fs-6 me-7">Action</span>
                    </Flex> */}
                </>
            }
        >
            <ChatModal data={chatData} front_user={f_user} chat_cession={chatSession} />
        </Drawer>
        </>
    )
}

export default ReportTable;